import {
  makeStyles, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Typography,
} from '@material-ui/core';
import React from 'react';
import { ControlProps } from './controlProps';
import surgicalApproaches from '../../Enums/SurgicalApproaches';
import ErrorText from './ErrorText';

const useStyles = makeStyles(() => ({
  label: {
    alignItems: 'flex-start',
  },
}));

function LaparscopicLabel(): JSX.Element {
  return (
    <>
      <Typography>Laparoscopic</Typography>
      <Typography style={{ fontSize: '0.9em' }}>
        {'(including laparoscopic-assisted vaginal hysterectomy (LAVH) and mini-laparotomy '}
        incision for morcellation after laparoscopic hysterectomy)
      </Typography>
    </>
  );
}

export default function SurgicalApproachControl(props: ControlProps): JSX.Element {
  const { value, error, handleChange } = props;
  const classes = useStyles();

  return (
    <FormControl component="fieldset" id="surgery-type">
      <FormLabel component="legend" style={{ color: 'black', fontWeight: 'bold' }}>What is the planned surgical approach to hysterectomy?</FormLabel>
      <RadioGroup aria-label="surgicalApproach" name="surgicalApproach" value={value} onChange={handleChange}>
        <FormControlLabel value={surgicalApproaches.find((approach) => approach === 'Open')} control={<Radio />} label="Abdominal/Open" />
        <FormControlLabel value={surgicalApproaches.find((approach) => approach === 'Laparoscopic')} control={<Radio />} label={<LaparscopicLabel />} className={classes.label} />
        <FormControlLabel value={surgicalApproaches.find((approach) => approach === 'Vaginal')} control={<Radio />} label="Vaginal" />
      </RadioGroup>
      <ErrorText error={error || false} errorText="You must select an option" />
    </FormControl>
  );
}
